import { PaneArea } from '../../../types/shared'
import Pitchfork, { IPitchforkAttrs } from '../../canvas/pitchfork/pitchfork_v1'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IPitchforkAttrs
type PartialAttrs = Partial<Attrs>

class PitchforkCreator extends Pitchfork<Attrs> {
  isCreator = true
  mouseDowns = 1

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = startArea.x
    this.attrs.y1 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns === 3) {
      this.release()
      this.replaceMyself(Pitchfork.fromObject<Pitchfork>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    switch (this.mouseDowns) {
      case 1:
        this.attrs.x2 = area.x
        this.attrs.y2 = area.y
        break
      case 2:
        this.attrs.x3 = area.x
        this.attrs.y3 = area.y
        break
      default:
        break
    }
    this.trigger('change')
  }
}

export default PitchforkCreator
